<div class="client-profile-section">
  <div class="client-profile-overview-section">
    <img
      [src]="base_url + advisor_data.profile_pic"
      onerror="this.src='assets/user-profile.png'"
      class="client-profile-image"
    />
    <p class="client-profile-name">
      {{ advisor_data.first_name }} {{ advisor_data.last_name }}
    </p>
    <p class="client-profile-id">({{ advisor_data.advisor_id }})</p>
    <div class="client-profile-member-section">
      <span class="client-profile-label">Advisor Since:</span>
      <span class="client-profile-value">{{
        advisor_data.date_of_joining | date: "dd MMM yyyy"
      }}</span>
    </div>
    <div class="client-profile-member-section">
      <span class="client-profile-label">Total Clients:</span>
      <span class="client-profile-value">{{
        commonService.abbreviateNumber(advisor_data.book_of_business.total_clients_count)
      }}</span>
    </div>
    <!-- <div class="client-profile-member-section">
      <span class="client-profile-label">Unique Clients:</span>
      <span class="client-profile-value">{{commonService.abbreviateNumber(advisor_data.book_of_business.unique_clients_count)}}</span>
    </div>
    <div class="client-profile-member-section">
      <span class="client-profile-label">Clients Across:</span>
      <span class="client-profile-value">{{commonService.abbreviateNumber(advisor_data.book_of_business.clients_across_count)}}</span>
    </div> -->
    <div class="client-profile-member-section">
      <span class="client-profile-label">AUM Reported:</span>
      <span class="client-profile-value"
        >{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(advisor_data.aum_self_reported) }}</span
      >
    </div>
    <div class="client-profile-member-section">
      <span class="client-profile-label">Attrition AUM:</span>
      <span class="client-profile-value"
        >{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(advisor_data.attrition_aum) }}</span
      >
    </div>
    <div class="client-profile-member-section">
      <span class="client-profile-label">Net AUM:</span>
      <span class="client-profile-value"
        >{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(advisor_data.net_new_aum) }}</span
      >
    </div>
    <div class="client-profile-member-section">
      <span class="client-profile-label">Products Sold:</span>
      <span class="client-profile-value">{{
        commonService.abbreviateNumber(advisor_data.book_of_business.no_of_products)
      }}</span>
    </div>
  </div>
  <div class="client-profile-details-block">
    <div class="client-products-section">
      <div class="client-products-tabs-section">
        <div
          class="each-client-products-tab"
          [ngClass]="{
            'each-client-products-tab-selected':
              selected_tab == 'Basic Information'
          }"
          (click)="selected_tab = 'Basic Information'"
        >
          <span>Basic Information</span>
        </div>
        <div
          class="each-client-products-tab"
          [ngClass]="{
            'each-client-products-tab-selected': selected_tab == 'Employment'
          }"
          (click)="selected_tab = 'Employment'"
        >
          <span>Employment</span>
        </div>
        <div
          class="each-client-products-tab"
          [ngClass]="{
            'each-client-products-tab-selected': selected_tab == 'Services'
          }"
          (click)="selected_tab = 'Services'"
        >
          <span>Services</span>
        </div>
        <!-- <div class="each-client-products-tab" [ngClass]="{'each-client-products-tab-selected': selected_tab == 'Current Employment'}" (click)="selected_tab = 'Current Employment'">
          <span>Current Employment</span>
        </div>
        <div class="each-client-products-tab" [ngClass]="{'each-client-products-tab-selected': selected_tab == 'Previous Employment'}" (click)="selected_tab = 'Previous Employment'">
          <span>Previous Employment</span>
        </div> -->
      </div>
      <div *ngIf="selected_tab == 'Basic Information'">
        <div class="client-profile-details-section">
          <p class="client-profile-details-heading">Personal Information</p>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Email ID:</span>
            <span class="client-profile-value">{{ advisor_data.email }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Date of Birth:</span>
            <span class="client-profile-value">{{
              advisor_data.date_of_birth | date: "dd MMM yyyy"
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Gender:</span>
            <span class="client-profile-value">{{ advisor_data.gender }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Phone Number:</span>
            <span class="client-profile-value">{{
              advisor_data.phone_number
            }}</span>
          </div>
        </div>
        <div class="client-profile-details-section">
          <p class="client-profile-details-heading">Contact Information</p>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Address:</span>
            <span class="client-profile-value">{{ advisor_data.address }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">City:</span>
            <span class="client-profile-value">{{ advisor_data.city }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">State:</span>
            <span class="client-profile-value">{{ advisor_data.state }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Zip Code:</span>
            <span class="client-profile-value">{{
              advisor_data.zip_code
            }}</span>
          </div>
        </div>
        <div class="client-profile-details-section">
          <p class="client-profile-details-heading">Experience/Qualification</p>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Total Experience:</span>
            <span class="client-profile-value">{{
              advisor_data.total_experience
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">States Registered:</span>
            <span class="client-profile-value"
              >{{ advisor_data.states_registered.length }}
              <span *ngIf="advisor_data.states_registered.length > 0"
                >({{ advisor_data.states_registered }})</span
              >
            </span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">No. of Licences:</span>
            <span class="client-profile-value">{{
              advisor_data.total_licenses_list.length
            }}</span>
            <span
              class="client-profile-value"
              *ngFor="
                let licence of advisor_data.total_licenses_list;
                let index = index
              "
            >
              <span *ngIf="index == 0">(</span>
              {{ licence.name }}
              <span *ngIf="index + 1 != advisor_data.total_licenses_list.length"
                >,
              </span>
              <span *ngIf="index + 1 == advisor_data.total_licenses_list.length"
                >)
              </span>
            </span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">No. of Certificates:</span>
            <span class="client-profile-value">{{
              advisor_data.certificates_list.length
            }}</span>
            <span
              class="client-profile-value"
              *ngFor="
                let certificate of advisor_data.certificates_list;
                let index = index
              "
            >
              <span *ngIf="index == 0">(</span>
              {{ certificate.name }}
              <span *ngIf="index + 1 != advisor_data.certificates_list.length"
                >,
              </span>
              <span *ngIf="index + 1 == advisor_data.certificates_list.length"
                >)
              </span>
            </span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Professional Associations:</span>
            <span class="client-profile-value">{{
              advisor_data.professional_associations.length
            }}</span>
            <span
              class="client-profile-value"
              *ngFor="
                let professional_association of advisor_data.professional_associations_list;
                let index = index
              "
            >
              <span *ngIf="index == 0">(</span>
              {{ professional_association.name }}
              <span
                *ngIf="
                  index + 1 !=
                  advisor_data.professional_associations_list.length
                "
                >,
              </span>
              <span
                *ngIf="
                  index + 1 ==
                  advisor_data.professional_associations_list.length
                "
                >)
              </span>
            </span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Advisor Type:</span>
            <span class="client-profile-value">{{
              advisor_data.advisor_type
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Dually Licensed:</span>
            <span class="client-profile-value">
              <!-- {{advisor_data.dually_licensed}} -->
              <span *ngIf="advisor_data.dually_licensed">Yes</span>
              <span *ngIf="!advisor_data.dually_licensed">No</span>
            </span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Regulatory Disclosures:</span>
            <span class="client-profile-value">
              <!-- {{advisor_data.regulatory_disclosures}} -->
              <span *ngIf="advisor_data.regulatory_disclosures">Yes</span>
              <span *ngIf="!advisor_data.regulatory_disclosures">No</span>
            </span>
          </div>
          <div class="each-client-profile-detail-section">
            <!-- <span class="client-profile-label"
              >Date became Representative:</span
            > -->
            <span class="client-profile-label"
              >Year became Representative:</span
            >
            <span class="client-profile-value">{{
              advisor_data.date_became_representative_year | date: "yyyy"
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Sells Insurance Products:</span>
            <span class="client-profile-value">
              <!-- {{advisor_data.sells_insurance_products}} -->
              <span *ngIf="advisor_data.sells_insurance_products">Yes</span>
              <span *ngIf="!advisor_data.sells_insurance_products">No</span>
            </span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Sells Retirement Products:</span>
            <span class="client-profile-value">
              <!-- {{advisor_data.sells_retirement_products}} -->
              <span *ngIf="advisor_data.sells_retirement_products">Yes</span>
              <span *ngIf="!advisor_data.sells_retirement_products">No</span>
            </span>
          </div>
        </div>
      </div>
      <div *ngIf="selected_tab == 'Employment'">
        <div class="client-profile-details-section">
          <p class="client-profile-details-heading">Current Employment</p>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Employment Id:</span>
            <span class="client-profile-value">{{
              advisor_data.employment_id
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Employment Type:</span>
            <span class="client-profile-value">{{
              advisor_data.employment_type
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Date of Joining:</span>
            <span class="client-profile-value">{{
              advisor_data.date_of_joining | date: "dd MMM yyyy"
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Company Name:</span>
            <span class="client-profile-value">{{
              advisor_data.financial_institution.institution_name
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Company Registration Type:</span>
            <span class="client-profile-value">{{
              advisor_data.financial_institution
                .institution_registration_type_name
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Branch ID:</span>
            <span class="client-profile-value">{{
              advisor_data.financial_institution_branch_details.branch_id
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Branch Name:</span>
            <span class="client-profile-value">{{
              advisor_data.financial_institution_branch_details.name
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Address:</span>
            <span class="client-profile-value">{{
              advisor_data.financial_institution_branch_details.address
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">City:</span>
            <span class="client-profile-value">{{
              advisor_data.financial_institution_branch_details.city
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">State:</span>
            <span class="client-profile-value">{{
              advisor_data.financial_institution_branch_details.state_name
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Zip Code:</span>
            <span class="client-profile-value">{{
              advisor_data.financial_institution_branch_details.zipcode
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Phone Number:</span>
            <span class="client-profile-value">{{
              advisor_data.financial_institution_branch_details.phone_number
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Email:</span>
            <span class="client-profile-value">{{
              advisor_data.financial_institution_branch_details.email
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Designation:</span>
            <span class="client-profile-value">{{
              advisor_data.designation
            }}</span>
          </div>
          <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Product Experience:</span>
            <span class="client-profile-value">{{
              advisor_data.product_experience_list.length
            }}</span>
            <span
              class="client-profile-value"
              *ngFor="
                let product of advisor_data.product_experience_list;
                let index = index
              "
            >
              <span *ngIf="index == 0">(</span>
              {{ product.name }}
              <span
                *ngIf="index + 1 != advisor_data.product_experience_list.length"
                >,
              </span>
              <span
                *ngIf="index + 1 == advisor_data.product_experience_list.length"
                >)
              </span>
            </span>
          </div>
        </div>
        <div class="client-profile-details-section">
          <p class="client-profile-details-heading">Previous Employment</p>

          <div *ngIf="advisor_data.employment_details.length > 0">
            <ngx-slick-carousel
              class="carousel"
              #slickModal="slick-carousel"
              [config]="graphSlideConfig"
            >
              <div
                ngxSlickItem
                class="each-product-section"
                *ngFor="let experience of advisor_data.employment_details"
              >
                <div class="each-product-detail-section">
                  <span class="each-product-detail-label">Company Name:</span>
                  <span class="each-product-detail-value">{{
                    experience.company_name
                  }}</span>
                </div>
                <div class="each-product-detail-section">
                  <span class="each-product-detail-label">Employment ID:</span>
                  <span class="each-product-detail-value">{{
                    experience.prior_employment_id
                  }}</span>
                </div>
                <div class="each-product-detail-section">
                  <span class="each-product-detail-label"
                    >Date of Joining:</span
                  >
                  <span class="each-product-detail-value">{{
                    experience.start_date | date: "dd MMM yyyy"
                  }}</span>
                </div>
                <div class="each-product-detail-section">
                  <span class="each-product-detail-label"
                    >Date of Leaving:</span
                  >
                  <span class="each-product-detail-value">{{
                    experience.end_date | date: "dd MMM yyyy"
                  }}</span>
                </div>
                <div class="each-product-detail-section">
                  <span class="each-product-detail-label"
                    >Total Work Experience:</span
                  >
                  <span class="each-product-detail-value"
                    >{{ experience.work_years }} Year
                    <span *ngIf="experience.work_years != 1">s</span></span
                  >
                </div>
              </div>
            </ngx-slick-carousel>
          </div>
          <div
            class="each-opportunity-zero-section"
            *ngIf="advisor_data.employment_details.length == 0"
          >
            <span>No Previous Employment Data Found</span>
          </div>
        </div>
      </div>
      <div *ngIf="selected_tab == 'Services'">
        <ng-container *ngFor="let service of advisor_data.services">
          <div class="each-service-section">
            <p class="each-service-name">{{ service.name }}</p>
            <p class="each-service-subscription">
              {{ service.type }}: {{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ service.cost }}/{{ service.duration }}
            </p>
            <p class="each-service-description">{{ service.description }}</p>
            <div class="each-service-tags-section">
              <span
                class="each-service-tag"
                *ngFor="let offer of service.services_offered_list"
                >{{ offer.name }}</span
              >
            </div>
          </div>
        </ng-container>
        <div
          class="each-opportunity-zero-section"
          *ngIf="advisor_data.services.length == 0"
        >
          <span>No Services Found</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="client-products-section">
  <p class="client-profile-details-heading">Sales History</p>
  <app-adv-mgr-perf [advisor_data_id]="advisor_data.id"></app-adv-mgr-perf>
</div>
